import './Avatar.scss';
import cn from 'classnames';
import { getAvatarProps } from './avatar-utils';

interface AvatarProps {
  name: string;
  color?: string;
  size?: number;
  className?: string;
}

export const Avatar = ({ name, color, size, className = '' }: AvatarProps) => {
  const { letter, bgColor } = getAvatarProps(name, color);

  return (
    <span
      className={cn('avatar', className)}
      style={{
        backgroundColor: bgColor,
        ...(size !== undefined && { width: size, height: size, fontSize: size * 0.5 })
      }}
    >
      {letter}
    </span>
  );
};
